module.exports = __webpack_public_path__ + "img/logo_text_bellow.586f55a4.png";